import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { AssignedProcedureDTO, ProcedureDTO } from '../Models/Procedure.model';
import { SpecialityDTO } from '../Models/Speciality.model';
import { Globals } from '../Models/UserProfile.model';
import { AppWideUser, Token } from "../Services/AppUserProfile";
import { SrubUpService } from '../Services/ScrubUp.service';
import { ApprovedOrDeclinedImageDTO, PendingApprovalDTO } from '../Models/PendingApproval.modal';
import { environment } from '../../environments/environment';
declare var swal: any;

@Component({
  selector: 'app-manage-approval',
  templateUrl: './manage-approval.component.html',
  styleUrls: ['./manage-approval.component.scss'],
  providers: [SrubUpService, CookieService]
})

export class ManageApprovalComponent implements OnInit {
  public baseurl: string = environment.base_url;
  pendingapproval :any;
  approvedImagesList: Array<ApprovedOrDeclinedImageDTO>;
  declinedImagesList: Array<ApprovedOrDeclinedImageDTO>;
  surgeonID:any;
  index: boolean;
  edit: boolean;
  imageTitle:string;
  imageToShow: string;
  universalHideAndShowMpId;

  public loading = false;
  nextButtonDisabled: boolean;

  invisible: number;
  editvisi: number;
  showEditingDiv: number;
  iValue: number;

  pendingApprovals: Array<PendingApprovalDTO>;

  loginUserId: number;
  imageUploadApiUrlLength: number;

  tempUrl: Array<string>;
  myHeaders: { [name: string]: any };

  constructor(private _sanitizer: DomSanitizer, private token: Token, private appUserDetails: AppWideUser, private cookieService: CookieService, private scrubUpService: SrubUpService) {
    if (this.appUserDetails.UserName == undefined && this.token.access_token == undefined || this.appUserDetails.UserName == null && this.token.access_token == null) {
      if (cookieService.check('AppWideUser') && cookieService.check('Token'))
        this.appUserDetails = JSON.parse(this.cookieService.get('AppWideUser'));
      this.token = JSON.parse(this.cookieService.get('Token'));
    }
    this.myHeaders = {
      'Authorization': 'Bearer ' + this.token.access_token,
      'UserId': this.appUserDetails.UserId,
      'ModulePath': "Admin Module"
    };
    this.tempUrl = new Array<string>();

    this.loginUserId = this.appUserDetails.UserId;
    this.pendingApprovals = new Array<PendingApprovalDTO>();
    this.approvedImagesList = new Array<ApprovedOrDeclinedImageDTO>();
    this.declinedImagesList = new Array<ApprovedOrDeclinedImageDTO>();

    this.index = true;
    //this.imageUploadApiUrlLength = (this.baseurl + "api/Speciality/GetUploadedImage?imageName=PendingApprovals/").length;

  }

  Collapse() {
    this.UserClick(1);
    this.invisible = 1;
  }
  UserClick(btnCount) {
    this.edit = false;

    if (btnCount == 1) {

      this.edit = true;
      this.showEditingDiv = -1;
    }
    if (btnCount == 3) {
      this.edit = false;
      this.invisible = 0;

    }
  }

  ShowImage(index,imagename,imagetitle) {
    this.imageToShow = imagename;
    this.imageTitle = imagetitle;

  }

  DeclineImages(pendingapproval) {
    swal({
      title: 'Are you sure?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Confirm',
      buttonsStyling: false,
      allowOutsideClick: false
    }).then(() => {
      if(pendingapproval.SurgeonID)
      {
        this.surgeonID = pendingapproval.SurgeonID;
      }
      else{
        this.surgeonID ="";
      }
      let declineimage = {
        "UserProcedureCheckListImageID": pendingapproval.SharedUserProcedureCheckListImageID,
        "UserProcedureCheckListID": pendingapproval.SharedUserProcedureCheckListID,
        "UserProcedureID": pendingapproval.SharedUserProcedureID,
        "isApproves": false,
        "SurgeonID":this.surgeonID
      }
      this.loading = true;
      this.scrubUpService.ApproveImages(this.token, declineimage).subscribe(x => {
        if (x['Status'] == true) {
          swal({
            title: 'Reported image has been kept and case has been resolved successfully!',
            type: "success",
            timer: 2000,
            showConfirmButton: false
          }).catch(swal.noop); 
            this.GetPendingApprovals();
       
        }
        else {
        }
       
       // this.GetPendingApprovals();
        this.loading = false;
        //this.GetPendingApprovals();
      });
      
    });
 
   // this.GetPendingApprovals();
  }

  ApproveImages(pendingapproval) {
    swal({
      title: 'Are you sure ?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-success',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Confirm',
      buttonsStyling: false,
      allowOutsideClick: false
    }).then(() => {
      if(pendingapproval.SurgeonID)
      {
        this.surgeonID = pendingapproval.SurgeonID;
      }
      else{
        this.surgeonID ="";
      }
      let approvedimage = {
        "UserProcedureCheckListImageID": pendingapproval.SharedUserProcedureCheckListImageID,
        "UserProcedureCheckListID": pendingapproval.SharedUserProcedureCheckListID,
        "UserProcedureID": pendingapproval.SharedUserProcedureID,
        "isApproves": true,
        "SurgeonID":this.surgeonID
      }

      this.loading = true;
      this.scrubUpService.ApproveImages(this.token, approvedimage).subscribe(x => {
        // console.log(x);

        if (x['Status'] == true) {
          swal({
            title: 'Reported image has been removed and case has been resolved successfully!',
            type: "success",
            timer: 2000,
            showConfirmButton: false
          }).catch(swal.noop);
            this.GetPendingApprovals();
    
        }
        this.loading = false;
      });
   
    });
  }

  // GetImage(imageSrc) {
  //   imageSrc.forEach(element => {
  //     this.scrubUpService.GetImageFormanageApproval(this.token, element, this.appUserDetails.UserId).subscribe(ab => {
  //       this.pendingApprovals.forEach(a => {
  //         if (a.ImageName == element) {
  //           a.ImageBase64 = "data:image/png;base64," + ab
  //         }
  //       });
  //     });

  //   });
  // }

  GetPendingApprovals() {
    this.pendingApprovals=[];
    this.loading = true;
    this.scrubUpService.GetPendingApprovals(this.token, this.appUserDetails.UserId).subscribe(x => {
    
      if (x['Data'] != null && x['Status'] == true) {
        this.pendingApprovals = x['Data'];
       
      }
      this.loading = false;
    },
      error => {
        this.loading = false;
      })
  }

  ngOnInit() {
    this.GetPendingApprovals();
     //this.DeclineImages(this.pendingapproval);
  }

}





// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/manage-approval/manage-approval.component.ts